module.exports = __webpack_public_path__ + "static/media/011_Risco_Totem_Reverso.139b7944.mp4";